import {Injectable} from '@angular/core';
import {throwError as observableThrowError} from 'rxjs';
import {RoutesEnums} from '../enums/RoutesEnums';
import {RedirectService} from './redirect.service';
import {ModalsControlService} from './modals-control.service';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApiHelper {
  constructor(
    private redirect: RedirectService,
    private modalControlService: ModalsControlService,
  ) {}

  public handleError(error: Response | any, ignore404 = false) {
    let errorMessage = '';
    if (error.error instanceof HttpErrorResponse) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      if (error.status === 0) {
        console.warn(`API response error: ${error.message}`);
      } else if (error.status === 404) {
        if (ignore404 !== true) {
          console.error(`API RETURNED 404: ${JSON.stringify(error)}`);
          this.modalControlService.closeAll();
          this.redirect.redirect(['/', RoutesEnums.NOTFOUND]);
        } else {
          console.log(`API RETURNED 404: ${JSON.stringify(error)}`);
        }
      } else {
        errorMessage = `Error Code: ${error.status}\rMessage: ${error.message}`;
      }
    }
    // console.error(`API ERROR: ${errorMessage}`, error);
    return observableThrowError(errorMessage);
  }
}
